var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSliderArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.719238,
    y: 21.2134,
    width: 30,
    height: 29,
    rx: 14.5,
    transform: "rotate(-45 0.719238 21.2134)",
    fill: "#F3F3F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0214 20.1529C26.4119 19.7624 26.4119 19.1292 26.0214 18.7387L19.6575 12.3747C19.2669 11.9842 18.6338 11.9842 18.2433 12.3747C17.8527 12.7652 17.8527 13.3984 18.2432 13.7889L23.9001 19.4458L18.2432 25.1026C17.8527 25.4932 17.8527 26.1263 18.2432 26.5169C18.6337 26.9074 19.2669 26.9074 19.6574 26.5169L26.0214 20.1529ZM24.9143 19.4458L24.9143 20.4458L25.3143 20.4458L25.3143 19.4458L25.3143 18.4458L24.9143 18.4458L24.9143 19.4458Z",
    fill: "#062A44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderArrowRight);
export default __webpack_public_path__ + "static/media/slider-arrow-right.abd29c4b27244b0fd47cd871e2db2419.svg";
export { ForwardRef as ReactComponent };